import React from "react";
import Dropzone from "react-dropzone";

import Icon from "material-ui-next/Icon";

const labels = {
  valid: "trocar o .csv",
  error: "trocar o .csv",
  absent: "anexar o .csv",
  invalid: "anexar um .csv válido"
};

const styles = {
  card: {
    display: "flex",
    flexDirection: "column"
  },
  inner: {
    cursor: "pointer",
    borderWidth: 2,
    borderColor: "#16303D",
    borderStyle: "dashed",
    borderRadius: 5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    height: 200,
    opacity: 0.6,
    fontWeight: 350,
    fontSize: 22,
    padding: "0px 12px"
  },
  outer: {
    margin: 0
  },
  placeholder: {
    fontWeight: 400,
    fontSize: 22,
    letterSpacing: 0.4,
    textTransform: "uppercase",
    color: "#F2B90D",
    textAlign: "center",
    marginBottom: 20,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
  },
  placeholderIcon: {
    fill: "#F2B90D"
  },
  placeholderContainer: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "center"
  },
  placeholderInvalid: {
    opacity: 1,
    color: "red"
  },
  placeholderInvalidIcon: {
    fill: "red"
  },
  placeholderValid: {
    opacity: 1,
    color: "green"
  },
  placeholderValidIcon: {
    fill: "green"
  }
};

const placeholders = {
  valid: (
    <div style={{ ...styles.placeholder, ...styles.placeholderValid }}>
      <Icon
        style={{
          ...styles.placeholderValidIcon,
          fontSize: "44px",
          width: "50px",
          padding: 0
        }}
      >
        done
      </Icon>
      Arquivo CSV válido!
    </div>
  ),
  error: (
    <div style={{ ...styles.placeholder, ...styles.placeholderInvalid }}>
      <Icon
        style={{
          ...styles.placeholderInvalidIcon,
          fontSize: "44px",
          width: "50px",
          padding: 0
        }}
      >
        not_interested
      </Icon>
      Esse arquivo contêm erros. Substitua-o.
    </div>
  ),
  absent: (
    <div style={{ ...styles.placeholder }}>
      <Icon
        style={{
          ...styles.placeholderIcon,
          fontSize: "44px",
          width: "50px"
        }}
      >
        warning
      </Icon>
      Você ainda não enviou o arquivo CSV.
    </div>
  ),
  invalid: (
    <div style={{ ...styles.placeholder, ...styles.placeholderInvalid }}>
      <Icon
        style={{
          ...styles.placeholderInvalidIcon,
          fontSize: "44px",
          width: "50px",
          padding: 0
        }}
      >
        not_interested
      </Icon>
      Ops! Esse arquivo é inválido. Tente novamente.
    </div>
  )
};

const StockCountDropzone = ({ status, onFileSelect }) => (
  <div>
    <Dropzone onDrop={onFileSelect} style={styles.outer} multiple={false}>
      <div style={styles.inner}>
        <div style={styles.placeholderContainer}>{placeholders[status]}</div>
        <span>Clique aqui para {labels[status]}</span>
        <span className="import-csv-instruction">
          ou arraste o arquivo até aqui.
        </span>
      </div>
    </Dropzone>
  </div>
);

export default StockCountDropzone;



// WEBPACK FOOTER //
// ./src/components/app/registration/product/inventory/adjust/import-stock-count/dropzone/index.js